const axios = require('axios');


const mutations = {
    /*THROW_ERROR(state, payload) {
        state.error.visible = true;
        state.error.message = payload.err;
        state.errors.push(state.error);

        let postUrl = payload.con.getters.backendServer + "error";
        let config = {
            headers: {
                auth: localStorage.getItem("token")
            }
        };

        let reqData = {
            statusCode: 500,
            message: payload.err.message
        };

        if(payload.err.response.status) {
            reqData.statusCode = payload.err.response.status;
        }

        axios
            .post(postUrl, reqData, config)
            .then(function (response) {})
            .catch(function (e) {
            });
    },*/
    CREATE_SNACKBAR(state, payload) {
        state.snackbar.visible = true;
        state.snackbar.message = payload;
    },
}

export default mutations;